import React from 'react';
import equal from 'fast-deep-equal';

function useDeepCompare(value) {
  var ref = React.useRef();

  if (!ref.current || !equal(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}
/**
 * The `useEffect` alternative which works when you have objects as dependencies for the hook
 * @param {function} callback callback function that should execute when dependencies change
 * @param {Array} dependencies Array of dependency values that includes one or more objects as a dependency
 */


export default function useEffectWithDeepCompare(callback, dependencies) {
  return React.useEffect(callback, useDeepCompare(dependencies));
}